export default __webpack_public_path__ + "static/media/bg_onboarding.cdff04e2.png";